module.exports = "/_next/static/images/einstein-d51c2052913b89bf23075e0f8484a710.png";